var exports = {
  "x6": "SettingsHeadingLinkButton.module__button___UUNoZG",
  "x2": "SettingsHeadingLinkButton.module__buttonCopied___UUNoZG",
  "Kk": "SettingsHeadingLinkButton.module__icon___UUNoZG",
};

module.exports = exports;
